import { render, staticRenderFns } from "./KnProductCategories.vue?vue&type=template&id=ab935b6e"
import script from "./KnProductCategories.js?vue&type=script&lang=js&external"
export * from "./KnProductCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports